import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SHOW_SUMMER_PASS, SHOW_MIDTERM_PASS } from '../utils/features';

/* ── Compact SVG Icons ── */
const icons = {
  home: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  games: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="6" y1="11" x2="10" y2="11" /><line x1="8" y1="9" x2="8" y2="13" />
      <line x1="15" y1="12" x2="15.01" y2="12" /><line x1="18" y1="10" x2="18.01" y2="10" />
      <path d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.544-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z" />
    </svg>
  ),
  pricing: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13 2L3 14h9l-1 10 10-12h-9l1-10z" />
    </svg>
  ),
  grub: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8h1a4 4 0 0 1 0 8h-1" /><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z" />
      <line x1="6" y1="1" x2="6" y2="4" /><line x1="10" y1="1" x2="10" y2="4" /><line x1="14" y1="1" x2="14" y2="4" />
    </svg>
  ),
  giftCards: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 12 20 22 4 22 4 12" /><rect x="2" y="7" width="20" height="5" />
      <line x1="12" y1="22" x2="12" y2="7" /><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
    </svg>
  ),
  events: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" /><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" /><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2z" />
    </svg>
  ),
  bookings: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  summerPass: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5" /><line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /><line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  ),
  blog: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" />
    </svg>
  ),
  gallery: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="m21 15-5-5L5 21" />
    </svg>
  ),
  faq: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  contact: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
};

const navItems = [
  { to: '/',            label: 'Home',     icon: icons.home,      color: '#12d0ff' },
  { to: '/games',       label: 'Games',    icon: icons.games,     color: '#12d0ff' },
  { to: '/pricing',     label: 'Pricing',  icon: icons.pricing,   color: '#ffc857' },
  { to: '/game-day-grub', label: 'Grub',     icon: icons.grub,      color: '#22c55e' },
  { to: '/gift-cards',  label: 'Gifts',    icon: icons.giftCards, color: '#7b2dff' },
  ...(SHOW_MIDTERM_PASS ? [{ to: '/daypass', label: 'Mid-Term', icon: icons.summerPass, color: '#f59e0b' }] : []),
  { to: '/party', label: 'Parties', icon: icons.bookings,  color: '#ff2d78' },
  ...(SHOW_SUMMER_PASS ? [{ to: '/summer-pass', label: 'Day Pass', icon: icons.summerPass, color: '#f59e0b' }] : []),
  // Events tab hidden — route still live, links keep working
  { to: '/championships', label: '',             icon: <img src="https://whapaxxgaming.com/assets/gt7-battle-royale.png" alt="GT7" style={{ width: 'auto', height: '100%', maxHeight: 44, objectFit: 'contain', pointerEvents: 'none' }} />, color: '#ffc857' },
  { to: '/blog',           label: 'Blog',         icon: icons.blog,      color: '#8b5cf6' },
  { to: '/gallery',        label: 'Snaps',        icon: icons.gallery,   color: '#ff2d78' },
  { to: '/faq',            label: 'FAQ',           icon: icons.faq,       color: '#12d0ff' },
  { to: '/contact',        label: 'Contact',       icon: icons.contact,   color: '#12d0ff' },
];

export default function FabMenu() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const toggle = useCallback(() => setOpen(v => !v), []);

  return (
    <>
      <style>{`
        .fab-wrap { display: none; }
        @media (max-width: 768px) { .fab-wrap { display: block; } }

        /* ── FAB button animations ── */
        @keyframes fabOrbPulse {
          0%, 100% { box-shadow: 0 0 18px rgba(18,208,255,0.4), 0 0 40px rgba(18,208,255,0.15), inset 0 0 12px rgba(18,208,255,0.1); }
          50%      { box-shadow: 0 0 24px rgba(18,208,255,0.6), 0 0 50px rgba(18,208,255,0.25), inset 0 0 16px rgba(18,208,255,0.15); }
        }
        @keyframes champFabPulse {
          0%, 100% { box-shadow: 0 0 18px rgba(255,200,87,0.4), 0 0 40px rgba(255,200,87,0.15), inset 0 0 12px rgba(255,200,87,0.1); }
          50%      { box-shadow: 0 0 24px rgba(255,200,87,0.6), 0 0 50px rgba(255,200,87,0.25), inset 0 0 16px rgba(255,200,87,0.15); }
        }
        @keyframes fabDotPulse {
          0%, 100% { opacity: 0.5; transform: scale(0.8); }
          50%      { opacity: 1; transform: scale(1.2); }
        }
        /* ── Dock tray animations ── */
        @keyframes fabTrayIn {
          from { opacity: 0; transform: translateY(100%); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes fabTrayItemIn {
          from { opacity: 0; transform: scale(0.7) translateY(12px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>

      <div className="fab-wrap">
        {/* Backdrop */}
        {open && (
          <div
            onClick={toggle}
            className="wpxg-scrim"
            style={{
              position: 'fixed', inset: 0, zIndex: 8998,
              background: 'rgba(5,8,31,0.88)',
              backdropFilter: 'blur(12px)',
              WebkitBackdropFilter: 'blur(12px)',
              transition: 'opacity 0.3s',
            }}
          />
        )}

        {/* ── Dock Tray Panel ── */}
        {open && (
          <div style={{
            position: 'fixed',
            bottom: 90,
            left: 16,
            right: 16,
            zIndex: 8999,
            background: 'linear-gradient(180deg, rgba(13,19,64,0.97) 0%, rgba(5,8,31,0.98) 100%)',
            borderRadius: 20,
            border: '1px solid rgba(18,208,255,0.12)',
            padding: '20px 12px 16px',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            boxShadow: '0 -8px 40px rgba(0,0,0,0.5), 0 0 30px rgba(18,208,255,0.08)',
            animation: 'fabTrayIn 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) both',
          }}>
            {/* Gradient accent line */}
            <div style={{
              position: 'absolute',
              top: 0, left: 20, right: 20,
              height: 2,
              borderRadius: '0 0 2px 2px',
              background: 'linear-gradient(90deg, #12d0ff, #8b5cf6, #ff2d78, #ffc857)',
              opacity: 0.6,
            }} />

            {/* 5×2 grid */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(5, 1fr)',
              gap: '12px 4px',
            }}>
              {navItems.map((item, i) => {
                const active = pathname === item.to;
                return (
                  <Link
                    key={item.to}
                    to={item.to}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 5,
                      textDecoration: 'none',
                      padding: '8px 2px 6px',
                      borderRadius: 12,
                      background: active ? `${item.color}12` : 'transparent',
                      border: active ? `1px solid ${item.color}25` : '1px solid transparent',
                      position: 'relative',
                      animation: `fabTrayItemIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) both`,
                      animationDelay: `${0.05 + i * 0.03}s`,
                      transition: 'background 0.2s, border 0.2s',
                    }}
                  >
                    {/* Icon */}
                    <div style={{
                      color: active ? item.color : 'rgba(234,242,255,0.5)',
                      transition: 'color 0.2s',
                      filter: active ? `drop-shadow(0 0 6px ${item.color}60)` : 'none',
                    }}>
                      {item.icon}
                    </div>
                    {/* Label */}
                    {item.label && <span style={{
                      fontFamily: "'Rajdhani', sans-serif",
                      fontSize: '0.65rem',
                      fontWeight: 600,
                      color: active ? item.color : 'rgba(234,242,255,0.55)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.03em',
                      lineHeight: 1,
                      transition: 'color 0.2s',
                      textShadow: active ? `0 0 8px ${item.color}40` : 'none',
                    }}>
                      {item.label}
                    </span>}
                    {/* Active dot indicator */}
                    {active && (
                      <div style={{
                        position: 'absolute',
                        bottom: 2,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: 4,
                        height: 4,
                        borderRadius: '50%',
                        background: item.color,
                        boxShadow: `0 0 6px ${item.color}`,
                      }} />
                    )}
                  </Link>
                );
              })}
            </div>
          </div>
        )}


        {/* ── Championship FAB — GT7 Logo ── */}
        {!open && (
          <Link
            to="/championships"
            onClick={(e) => { e.stopPropagation(); }}
            aria-label="GT7 Battle Royale Championship"
            style={{
              position: 'fixed',
              bottom: 100,
              right: 20,
              zIndex: 9001,
              width: 62,
              height: 62,
              borderRadius: '50%',
              background: 'radial-gradient(circle at 35% 35%, #2a1a00, #1a0f00 60%, #0d0800)',
              border: '1.5px solid rgba(255,200,87,0.3)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              animation: 'champFabPulse 2.5s ease-in-out infinite',
              transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
              cursor: 'pointer',
              WebkitTapHighlightColor: 'transparent',
            }}
          >
            <img
              src="https://whapaxxgaming.com/assets/gt7-battle-royale.png"
              alt="GT7 Battle Royale"
              width="60"
              height="60"
              style={{ objectFit: 'contain', filter: 'drop-shadow(0 0 6px rgba(255,200,87,0.5))', pointerEvents: 'none' }}
            />
          </Link>
        )}

        {/* ── FAB Button — Neon Orb ── */}
        <button
          onClick={toggle}
          aria-label="Navigation menu"
          style={{
            position: 'fixed',
            bottom: 24,
            right: 20,
            zIndex: 9000,
            width: 62,
            height: 62,
            borderRadius: '50%',
            border: 'none',
            background: open
              ? 'linear-gradient(135deg, #ff2d78, #8b5cf6)'
              : 'radial-gradient(circle at 35% 35%, #1e2b7a, #0a0f3a 60%, #05081f)',
            color: '#fff',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: open ? 'none' : 'fabOrbPulse 3s ease-in-out infinite',
            transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
            transform: open ? 'scale(1.05) rotate(0deg)' : 'scale(1)',
            boxShadow: open
              ? '0 0 24px rgba(255,45,120,0.5), 0 0 48px rgba(139,92,246,0.2), inset 0 0 12px rgba(255,45,120,0.15)'
              : undefined, /* handled by animation */
            outline: 'none',
            WebkitTapHighlightColor: 'transparent',
            overflow: 'hidden',
          }}
        >
          {/* Inner glow ring */}
          <div style={{
            position: 'absolute',
            inset: 2,
            borderRadius: '50%',
            border: `1px solid ${open ? 'rgba(255,255,255,0.2)' : 'rgba(18,208,255,0.25)'}`,
            transition: 'border 0.3s',
            pointerEvents: 'none',
          }} />

          {/* Icon content: Gamepad → X morph */}
          <div style={{
            position: 'relative',
            width: 22,
            height: 22,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            {/* Close X (visible when open) */}
            <div style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: open ? 1 : 0,
              transform: open ? 'rotate(0deg) scale(1)' : 'rotate(-90deg) scale(0.5)',
              transition: 'all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
            }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="6" y1="6" x2="18" y2="18" />
                <line x1="18" y1="6" x2="6" y2="18" />
              </svg>
            </div>

            {/* 4-dot grid icon (visible when closed) */}
            <div style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: open ? 0 : 1,
              transform: open ? 'rotate(90deg) scale(0.5)' : 'rotate(0deg) scale(1)',
              transition: 'all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
            }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: 5,
              }}>
                {[0,1,2,3].map(j => (
                  <div key={j} style={{
                    width: 5,
                    height: 5,
                    borderRadius: '50%',
                    background: '#12d0ff',
                    boxShadow: '0 0 6px rgba(18,208,255,0.6)',
                    animation: 'fabDotPulse 2s ease-in-out infinite',
                    animationDelay: `${j * 0.3}s`,
                  }} />
                ))}
              </div>
            </div>
          </div>
        </button>
      </div>
    </>
  );
}
